<template>
  <div :class="cardClasses">
    <div v-if="title" class="bg-gray-100 p-4 border-b-4 border-black">
      <h3 class="font-bold text-xl uppercase tracking-wider">{{ title }}</h3>
    </div>
    <div class="p-4">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  title?: string
  color?: 'white' | 'blue' | 'green' | 'red' | 'yellow' | 'purple' | 'gray'
  padding?: 'none' | 'sm' | 'md' | 'lg'
  shadow?: 'sm' | 'md' | 'lg' | 'xl'
}

const props = withDefaults(defineProps<Props>(), {
  color: 'white',
  padding: 'md',
  shadow: 'md'
})

const cardClasses = computed(() => {
  const baseClasses = [
    'border-4',
    'border-black',
    'bg-white',
    'transform',
    'transition-all',
    'duration-150'
  ]
  
  // Color classes
  const colorClasses = {
    white: ['bg-white'],
    blue: ['bg-blue-200'],
    green: ['bg-green-200'],
    red: ['bg-red-200'],
    yellow: ['bg-yellow-200'],
    purple: ['bg-purple-200'],
    gray: ['bg-gray-200']
  }
  
  // Shadow classes
  const shadowClasses = {
    sm: ['shadow-[3px_3px_0px_0px_rgba(0,0,0,1)]'],
    md: ['shadow-[5px_5px_0px_0px_rgba(0,0,0,1)]'],
    lg: ['shadow-[7px_7px_0px_0px_rgba(0,0,0,1)]'],
    xl: ['shadow-[10px_10px_0px_0px_rgba(0,0,0,1)]']
  }
  
  return [
    ...baseClasses,
    ...colorClasses[props.color],
    ...shadowClasses[props.shadow]
  ]
})
</script> 